import { Box, Container } from '@mui/material';
import clsx from 'clsx';
import { useStyles } from './styles';

export default function StepPersonalAndPayment({ inactiveStep }) {
  const classes = useStyles();

  return (
    <Box>
      <Container>
        <Box display="flex" justifyContent="center" alignItems="center">
          <p
            className={clsx(classes.stepNumber, {
              [classes.stepNumberInactive]: inactiveStep === 1,
            })}
          >
            1
          </p>

          <div className={classes.dividerPurple} />

          <p
            className={clsx(classes.stepNumber, {
              [classes.stepNumberInactive]: inactiveStep === 2,
            })}
          >
            2
          </p>
        </Box>

        <Box display="flex" justifyContent="center" alignItems="center" gap="80px" mt={-3} mr={2}>
          <p>Personal info</p>
          <p>Payment</p>
        </Box>
      </Container>
    </Box>
  );
}
